import uniqBy from 'lodash/uniqBy'
import type { GeckoComponentDataFrame } from 'types'

/** Returns the CDFs with duplicate ids removed, keeping the first occurrence. */
export function uniqueCdfsById(
  cdfs: readonly GeckoComponentDataFrame[]
): GeckoComponentDataFrame[] {
  return uniqBy(cdfs, (cdf) => cdf.id)
}
